import React from 'react'

import {
  ItemSelector,
  type ItemSelectorProps,
} from '~/components/elements/ItemSelector'
import { type GroupAndAll } from '~/utils'

import { useGroupAndAllNameMap } from '../hooks/useGroupAndAllNameMap'

type GroupSelectorItem = {
  group: GroupAndAll
  name: string
}

export type GroupSelectorProps = Pick<ItemSelectorProps, 'onBlur'> & {
  value: GroupAndAll | null
  groups: GroupAndAll[]
  onChange?: (group: GroupAndAll) => void
}

export const GroupSelector = React.forwardRef<
  HTMLSpanElement,
  GroupSelectorProps
>(({ groups, onChange, value: valueProp, ...rest }, ref) => {
  const groupAndAllNameMap = useGroupAndAllNameMap()
  const data = React.useMemo(
    () => groups.map((group) => ({ group, name: groupAndAllNameMap[group] })),
    [groupAndAllNameMap, groups],
  )

  const value = React.useMemo(
    () => data.find((item) => item.group === valueProp),
    [data, valueProp],
  )

  const handleChange = React.useCallback<EH<ItemSelectorProps, 'onChange'>>(
    (item: GroupSelectorItem) => {
      onChange?.(item.group)
    },
    [onChange],
  )

  return (
    <ItemSelector
      ref={ref}
      data={data}
      dataItemKey="group"
      textField="name"
      value={value}
      width={240}
      onChange={handleChange}
      {...rest}
    />
  )
})
